import { COLORS } from "components/consts";
import { SIDEBAR_DIMENSIONS } from "./consts";

export const listItemStyles = (isOpen: boolean) => ({
  display: "flex",
  width: "100%",
  flexDirection: isOpen ? "row" : "column",
  justifyContent: isOpen ? "flex-start" : "center",
  padding: 0,
});

export const listItemButtonStyles = (
  isOpen: boolean,
  isSelected?: boolean,
) => ({
  ...(isOpen
    ? {
        display: "block",
        padding: 0,
        marginLeft: SIDEBAR_DIMENSIONS.MARGIN_LEFT,
      }
    : {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 0.5,
        padding: "10px 4px",
        width: "100%",
      }),
  borderRadius: 2,
  "&.Mui-selected": {
    backgroundColor: "background.default",
    "& svg": {
      color: "primary.main",
    },
    ":hover": {
      backgroundColor: "background.default",
    },
  },
  "&.Mui-focusVisible": {
    backgroundColor: "background.default",
  },
  ":hover": {
    backgroundColor: isOpen ? "transparent" : "action.hover",
    color: isSelected ? undefined : "primary.main",
    "& svg": {
      color: "primary.main",
    },
  },
});

export const iconContainerStyles = (isOpen: boolean) => ({
  display: "flex",
  justifyContent: isOpen ? "flex-start" : "center",
  alignItems: "center",
});

export const listItemIconStyles = (isOpen: boolean) => ({
  justifyContent: "center",
  minWidth: isOpen
    ? SIDEBAR_DIMENSIONS.ICON_MIN_WIDTH_OPEN
    : SIDEBAR_DIMENSIONS.ICON_MIN_WIDTH_CLOSED,
});

export const listItemTextStyles = (isOpen: boolean) => ({
  display: isOpen ? "block" : "none",
  fontSize: "16px",
  color: COLORS.Romance,
  marginLeft: isOpen ? SIDEBAR_DIMENSIONS.TEXT_MARGIN_LEFT : undefined,
  "& .MuiListItemText-primary": {
    fontWeight: 400,
    color: COLORS.Romance,
    fontFamily: "Inter",
    fontStyle: "normal",
    lineHeight: "24px",
  },
});

export const sidebarTitleStyles = {
  display: "flex",
  justifyContent: "center",
};

export const sidebarTitleTextStyles = {
  fontSize: "12px",
  color: COLORS.Romance,
  fontWeight: 400,
  fontFamily: "Inter",
  fontStyle: "normal",
  lineHeight: "16px",
  textAlign: "center",
  textWrap: "wrap",
};
